import React from "react";
import "./ChoseDetailPopover.less";
import { Popover, Tag, TooltipProps } from "@arco-design/web-react";
import { IconClose } from "@arco-design/web-react/icon";

interface IChoseDetailPopover<T> {
  handleTagCloseBtnClick: (state: boolean, id: any, media_id: string) => void;
  handleClearBtnClick: () => void;
  position?: TooltipProps["position"];
  data: any;
  title: string;
  selfCoverData: any;
}

const ChoseDetailPopover = <T,>(
  props: IChoseDetailPopover<T>,
): React.ReactElement => {
  const {
    position,
    handleTagCloseBtnClick,
    data,
    title,
    handleClearBtnClick,
    selfCoverData
  } = props;
  const getName = (id) => {
    const findObj = selfCoverData.find((item1: any) => item1.media_id === id);
    console.log(findObj, 'findObj')
    return findObj?.name;
  };
  return (
    <div className="chose-detail-bar-wrapper">
      {data && data?.length > 0 ? (
        <span style={{ cursor: "pointer" }}>
          <span>已选择</span>： <span style={{ color: 'rgb(22, 93, 255)' }}>{data.length}</span>
          <Popover
            position={`${position || "br"}`}
            className="chose-detail-popover-wrapper"
            content={
              <div className="chose-detail-content-wrapper">
                {/*<div className="title-wrapper">*/}
                {/*  <span>*/}
                {/*    {title}(已选择{data.length})*/}
                {/*  </span>*/}
                {/*  <span*/}
                {/*    style={{ cursor: "pointer" }}*/}
                {/*    onClick={() => {*/}
                {/*      handleClearBtnClick();*/}
                {/*    }}>*/}
                {/*    清空*/}
                {/*  </span>*/}
                {/*</div>*/}
                <div className="chose-detail-content">
                  {(data || []).map((item) => (
                    <Tag
                      key={item?.toString()}
                      color={"blue"}
                      style={{ margin: "2px 2px" }}
                      className="chose-detail-popover-item">
                      {getName(item.material.media_id)}
                      <span>
                        <IconClose
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            const value = item.material.media_id;
                            if (
                              typeof value === "string"
                            ) {
                              handleTagCloseBtnClick(false, null, value);
                            }
                          }}
                        />
                      </span>
                    </Tag>
                  ))}
                </div>
              </div>
            }>
            <span
              style={{
                cursor: "pointer",
                color: "#165dff",
                marginLeft: "10px",
              }}>
              查看详情
            </span>
          </Popover>
          <span
            style={{ marginLeft: "10px" }}
            onClick={() => {
              handleClearBtnClick();
            }}>
            清空
          </span>
        </span>
      ) : (
        <span>已选择：{ data?.length || 0 }</span>
      )}
    </div>
  );
};

export default ChoseDetailPopover;
